module.exports = __webpack_public_path__ + "img/login-clementeballen.8b4e8877.svg";